import { createContext, useContext, type ReactNode } from 'react';

import type { DataPointDoc } from '@/types/analytics';

/**
 * The data-point documentation for the boards the current user may see, keyed
 * "<board>.<dataPoint>".
 *
 * Cards look their own entry up rather than receiving it as a prop: the six
 * analytics modules render ~40 tiles and charts between them, and threading a
 * docs object through every one of them would be noise. A missing key simply
 * means that card has no (i) button yet.
 */
const AnalyticsDocsContext = createContext<Record<string, DataPointDoc>>({});

export function AnalyticsDocsProvider({ docs, children }: { docs?: Record<string, DataPointDoc>; children: ReactNode }) {
    return <AnalyticsDocsContext.Provider value={docs ?? {}}>{children}</AnalyticsDocsContext.Provider>;
}

export function useDataPointDoc(docKey?: string): DataPointDoc | undefined {
    const docs = useContext(AnalyticsDocsContext);

    return docKey ? docs[docKey] : undefined;
}
